import { ref, onMounted } from 'vue'
import { ItemWrapper } from '@/wrappers'
import { BriefcaseIcon } from '@heroicons/vue/24/outline'
import type { Company, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useCompany(skipLoading: boolean = false) {

    const baseForm: FormData = {
        name: null
    };

    const wrapper = new ItemWrapper<Company>("companies");

    const empty = {...baseForm};

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const companies = ref<Company[]>([]);
    const companyOptions = ref<FormSelectOption[]>([]);

    async function addCompany(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading};

        await wrapper.addItem(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.data = {...empty};
        request.value.isLoading = !request.value.isLoading;
    }

    function getAsFormOptions(): void {
        companyOptions.value = companies.value.map(company => {
            return {
                value: company.id,
                label: company.name,
                icon: BriefcaseIcon
            }
        });
    }

    async function getCompanies(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getItems().then((data) => companies.value = data);

        getAsFormOptions();
        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }

    onMounted(() => {
        if (skipLoading) return;

        getCompanies();
    });

    return {
        info,
        request,
        companies,
        companyOptions,
        getInfo,
        addCompany,
        getCompanies
    }
}